import { toLatLngLiteral } from "../../../../../utils/geo";
import type {
  ProposedRoute,
  RouteBuilderSession,
  RouteEndpointLocation,
} from "../../../../../types/routeBuilder";

export function hasValidRouteEndpoint(
  endpoint: RouteEndpointLocation | null | undefined,
): boolean {
  return toLatLngLiteral(endpoint?.location) != null;
}

export function isPersistedEditRoute(
  session: RouteBuilderSession,
  route: ProposedRoute,
): boolean {
  return Boolean(
    session.builderMode === "edit" && session.routePersistence?.[route.id],
  );
}

export function hasValidRouteEndpoints(
  route: Pick<ProposedRoute, "startLocation" | "endLocation">,
): boolean {
  return (
    hasValidRouteEndpoint(route.startLocation) &&
    hasValidRouteEndpoint(route.endLocation)
  );
}

export function canApplyRouteBuilderSession(
  session: RouteBuilderSession | null,
): boolean {
  return Boolean(
    session?.routes.length &&
      session.routes.every(
        (route) =>
          route.stops.length > 0 &&
          (isPersistedEditRoute(session, route) ||
            hasValidRouteEndpoints(route)),
      ),
  );
}
